import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  _id: "",
  firstName: "",
  lastName: "",
  nickName: "",
  rol: "Runner",
  address: {},
  dateBirth: "",
  email: "",
  emailVerified: false,
  gender: "",
  phoneNumber: "",
  phoneVerified: false,
  urlImg: "",
  status: "inactive",
  isAuthenticate: false,
  weight: 0,
  height: 0,
  preferences: {},
  userType: "user",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        isAuthenticate: true,
      };
    },
    athenticate: (state) => {
      state.isAuthenticate = true;
    },
    updateStatusAccount: (state, action) => {
      state.status = action.payload.status;
    },
    setBodyData: (state, action) => {
      state.weight = action.payload.weight;
      state.height = action.payload.height;
    },
    setPreferences: (state, action) => {
      state.preferences = {
        horario: action.payload.horario,
        terreno: action.payload.terreno,
        distancia: action.payload.distancia,
      };
    },
    clearUserData: (state) => {
      return { ...initialState };
    },
  },
});
export { initialState };
export const {
  setUserData,
  updateMembership,
  updateStatusAccount,
  athenticate,
  setBodyData,
  setPreferences,
  clearUserData,
} = userSlice.actions;
export default userSlice.reducer;
